import FileSaver from "file-saver";
import * as XLSX from "xlsx";
export default {
  name: "ConfigTable",
  props: {
    tableData: {
      type: Object
    },
    apiEdit: {
      type: Function
    },
    apiDel: {
      type: Function
    },
    height: {
      type: String,
      default: ""
    },
    col: {
      type: Number
    },
    row: {
      type: Number
    },
    rowKey: {
      type: String
    },
    treeProps: {
      type: Object
    },
    indent: {
      type: Number
    },
    isBorder: {
      type: Boolean
    },
    isStripe: {
      type: Boolean
    },
    lazy: {
      type: Boolean
    },
    rowClass: {
      type: Boolean,
      default: false
    },
    cellClass: {
      type: Object
    },
    lazyLoad: {
      type: Function
    },
    expandRowKeys: {
      type: Array
    },
    size: {
      type: String,
      default: "small"
    },
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    elTableDom() {
      return this.$refs.elTable;
    }
  },
  methods: {
    /**
     * 操作-编辑
     */
    edit(row) {
      this.apiEdit(row);
    },
    /**
     * 操作-删除
     */
    del(row) {
      this.$confirm("此操作将永久删除这条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.apiDel(row);
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    /**
     * 操作-详情
     */
    details(row) {
      this.apiDetails(row);
    },
    /**
     * 特殊字符转义
     */
    formatter(row, field) {
      return row[field];
    },
    /**
     * 图片数据渲染
     */
    imageHandle(row, field) {
      return row[field];
    },
    /**
     * 批量操作
     */
    selectBatch(val) {
      this.$emit("selectBatch", val);
    },
    /**
     * 单元格点击
     */
    handleCellClick(row, column, cell, event) {
      this.$emit("handleCellClick", row, column, cell, event);
    },
    /**
     * 一页显示多少条数据改变
     */
    handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
    },
    /**
     * 当前页面改变
     */
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    cellStyle({
      rowIndex,
      columnIndex
    }) {
      if (this.col !== -1 && this.row !== -1) {
        if (columnIndex === this.col && rowIndex === this.row) {
          return "color:red;font-weight:bold;font-size:16px";
        }
      }
    },
    /**
     * 重计算表格
     */
    doLayout() {
      this.$refs.elTable.doLayout();
    },
    /**
     * 发送展开事件
     */
    onExpandChange(row, expanded) {
      this.$emit("expandChange", row, expanded);
    },
    /**
     * excel导出
     */
    exportExcel(excelName) {
      try {
        const $e = this.$refs["elTable"].$el;
        let $table = $e.querySelector(".el-table__fixed");
        if (!$table) {
          $table = $e;
        }
        const wb = XLSX.utils.table_to_book($table, {
          raw: true
        });
        const wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        FileSaver.saveAs(new Blob([wbout], {
          type: "application/octet-stream"
        }), `${excelName}.xlsx`);
      } catch (e) {
        if (typeof console !== "undefined") console.error(e);
      }
    },
    /**
     * 某一行样式
     */
    rowClassName({
      row,
      rowIndex
    }) {
      if (rowIndex % 2 == 0) {
        return "rowColor";
      } else {
        return "";
      }
    },
    /**
     * 某一单元格样式
     */
    tableCellClassName({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (this.cellClass.length - 1 == rowIndex) {
        return "font-blod";
      } else {
        return "";
      }
    }
  }
};